import {
  BehaviorSubject,
  catchError,
  delay,
  filter,
  from,
  mergeMap,
  Observable,
  of,
} from 'rxjs';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import {
  retrieveFights,
  retrieveFightsFailure,
  retrieveFightsSuccess,
} from '../../../state/fight/fight.action';
import {
  RetrieveFights,
  RETRIEVE_FIGHTS,
} from '../../../state/fight/fight.action.type';
import { Fight } from '../../models/fight.model';

const DEFAULT_RETRY_DELAY = 300;

export const retrieveFightsUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: AnyAction): action is RetrieveFights =>
        action.type === RETRIEVE_FIGHTS,
    ),
    mergeMap((action: RetrieveFights) =>
      from(dependencies.fightGateway.getFights()).pipe(
        mergeMap((fights: Fight[]) => {
          return [retrieveFightsSuccess(fights)];
        }),
        catchError((error: Error) => {
          console.warn(error.message);
          const remainingRetries = action.payload.retry
            ? action.payload.retry - 1
            : 0;
          if (remainingRetries) {
            return of(retrieveFights({ retry: remainingRetries })).pipe(
              delay(DEFAULT_RETRY_DELAY),
            );
          }
          return of(retrieveFightsFailure(`${error.message}`));
        }),
      ),
    ),
  );
